"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INTERACTION_PROCESS_SUPPORT_PORTAL_MTC_DECEASED = exports.INTERACTION_PROCESS_MTC_LV = exports.INTERACTION_PROCESS_SUPPORT_PORTAL_MTC = exports.INTERACTION_PROCESS_MTC_FORCED = exports.INTERACTION_PROCESS_MTC = void 0;
// MTC processes
exports.INTERACTION_PROCESS_MTC = "mtc";
exports.INTERACTION_PROCESS_MTC_FORCED = "mtcForced";
exports.INTERACTION_PROCESS_SUPPORT_PORTAL_MTC = "supportPortalCancellation";
exports.INTERACTION_PROCESS_MTC_LV = "mtcLV";
exports.INTERACTION_PROCESS_SUPPORT_PORTAL_MTC_DECEASED = "mtcSupportPortalAnnualDeceased";
//# sourceMappingURL=interactionConstants.js.map